"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InfoBar = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/styles");
var _excluded = ["className"];
/*:: import { type ThemeType } from '../../style/ThemeTypes';*/
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    root: (0, _defineProperty2.default)({
      padding: '1rem 0'
    }, theme.breakpoints.gte.tablet.portrait, {
      display: 'flex',
      justifyContent: 'flex-start'
    })
  };
});
var InfoBar = exports.InfoBar = function InfoBar(_ref /*:: */) {
  var className = _ref /*:: */.className,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("section", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, props));
};
var _default = exports.default = InfoBar;
//# sourceMappingURL=InfoBar.js.map